import React from "react";

import { BadgeContainer, TicketHolder, TickerOfferExpirationTypography, ImageContainer, TicketOfferExpiresContainer, TicketHolderContainer, TicketOfferCardContainer, TicketOfferCardContentContainer } from "./TicketOfferCard.styles";
import { MeshGradient, MeshColours, SessionDetails, Badge, TicketDetails } from "..";
import {
  SessionDetailsInterface,
} from "../../models/Session";
import { Icon } from "../../icons";
import Image from "next/image";
import { Dayjs } from "dayjs";

export interface CustomTicketOfferCardProps {
  showName?: string | null;
  showMinimumAge?: number | null;
  sessionDetails?: SessionDetailsInterface | null;
  ticketHolders?: TicketDetails[];
  isDeletable?: boolean,
  colour?: MeshColours,
  invitedToTicketExpiration?: Dayjs,
  isPriority?: boolean,
}

export const TicketOfferCard = ({
  showName,
  sessionDetails,
  ticketHolders,
  isDeletable = false,
  colour = "pink-purple-green",
  showMinimumAge,
  invitedToTicketExpiration,
  isPriority = false,
  ...rest
}: CustomTicketOfferCardProps) => {

  const hasAccessibility = ticketHolders?.some((element) => element.hasAccessibilityRequirements || element.accessibilityRequestStatus === "Accepted");
  const ticketType = isPriority
    ? (hasAccessibility ? "priorityAccessibility" : "priority")
    : hasAccessibility
      ? "accessibilityRequired"
      : "generalAdmission";

  const formattedExpirationDate = invitedToTicketExpiration?.format("D MMM YYYY h:mm A")

  return (
    <TicketOfferCardContainer {...rest}>
      <TicketOfferCardContentContainer>
        {ticketHolders && ticketHolders.map((ticketHolder, index) => {
            return (
              <TicketHolderContainer key={`ticket-holder-${index}`} isPriority={isPriority}>
                <Icon icon="User"/>
                <TicketHolder>{ticketHolder.user.firstName} {ticketHolder.user.lastName}</TicketHolder>
                <BadgeContainer>
                  {ticketHolder.userAgeAtBooking && ticketHolder.userAgeAtBooking < 18 &&
                    <Badge badgeStyle="underAge" />}
                  {ticketHolder.isLeadBooker &&
                    <Badge badgeStyle="leadBooker" />}
                  {ticketHolder.hasAccessibilityRequirements &&
                    <Badge badgeStyle="accessibilityRequired" />}
                </BadgeContainer>
              </TicketHolderContainer>
            );
          })}
        <SessionDetails showName={showName} showMinimumAge={showMinimumAge} sessionDetails={sessionDetails} ticketType={ticketType} isPriority={isPriority} />
        <ImageContainer>
          <Image src="/images/email/barcode-locked.png" fill={true} alt="locked-ticket"/>
        </ImageContainer>
        <TicketOfferExpiresContainer>
          <TickerOfferExpirationTypography>
            Ticker Offer Expires at:
          </TickerOfferExpirationTypography>
          <TickerOfferExpirationTypography>
            {formattedExpirationDate}
          </TickerOfferExpirationTypography>
        </TicketOfferExpiresContainer>
      </TicketOfferCardContentContainer>
      <MeshGradient colour={colour} intensity="high" position="bottom" size="high" sx={{ top: ticketHolders && ticketHolders.length > 0 ? 0 : "auto" }} />
    </TicketOfferCardContainer>
  );
};

export interface TicketOfferCardProps
  extends React.ComponentProps<typeof TicketOfferCard> {
  as?: React.ElementType;
}

TicketOfferCard.displayName = "TicketOfferCard";
